import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiPost } from '../../utils/api'
import { usePageTitle } from '../../contexts/PageTitleContext'
import '../../css/FindPassword/findPassword.css'

const FindPassword = () => {
    const navigate = useNavigate();
    const { setPageTitle } = usePageTitle();
    const [formValues, setFormValues] = useState({
        name: '',
        email: '',
    });

    const isFormValid = formValues.name.trim() !== '' && formValues.email.trim() !== '';

    useEffect(() => {
        setPageTitle('비밀번호 찾기');
    }, [setPageTitle]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const response = await apiPost('/member/findPw.php', {
                name: formValues.name.trim(),
                email: formValues.email.trim(),
            });

            if (!response?.success) {
                alert({
                    title: '에러',
                    content: <p>{response?.message || '임시 비밀번호 발급에 실패했습니다.'}</p>,
                    showConfirmButton : false,
                    footerContent: <button type="button" className="btn">확인</button>,
                });
                return;
            }

            alert({
                title: '임시 비밀번호가 발급되었습니다.',
                content: <p>이메일을 확인해주세요. 임시 비밀번호로 로그인 하신 후, <span style={{color:'#0066FF'}}>마이페이지&gt;회원 정보&gt;비밀번호 변경</span> 페이지에서 비밀번호를 변경하실 수 있습니다.</p>,
                showConfirmButton : true,
                footerContent: <button type="button" className="btn">로그인</button>,
                action: () => {
                    navigate(`/login`);
                },
            });
        } catch (error) {
            console.error('임시 비밀번호 발급 요청 중 오류가 발생했습니다.', error);
            const errorMessage = error?.response?.data?.message || '임시 비밀번호 발급 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';

            alert({
                title: '에러',
                content: <p>{errorMessage}</p>,
                showConfirmButton : false,
                footerContent: <button type="button" className="btn">확인</button>,
            });
        }
    };

    return (
        <div className='forgot-password-wrapper'>
            <div className='forgot-password'>
                <div className='password-text'>
                    <h2 className='text-title'>임시 비밀번호 발급</h2>
                    <p className='text-desc'>
                        가입한 이름과 이메일 주소를 입력하시면, 해당 이메일로 임시 비밀번호를 보내드립니다. 비밀번호는 <span>마이페이지&gt;회원 정보&gt;비밀번호 변경</span> 에서 변경하실 수 있습니다.
                    </p>
                </div>

                {/* 임시 비밀번호 발급 신청 폼 */}

                {/* <form onSubmit={handleSubmit} className='password-content-form'>  */}
                <form onSubmit={handleSubmit} className='password-content-form'> 
                    <div className='password-content-wrapper'>
                        <div className='input-wrapper'>
                            <label htmlFor='user-name' className='required'>이름</label>
                            <input
                                type='text'
                                className='user-name'
                                id='user-name'
                                name='name'
                                value={formValues.name}
                                onChange={handleChange}
                                placeholder='가입하신 이름을 입력해 주세요.'
                            />
                        </div>

                        <div className='input-wrapper'>
                            <label htmlFor='user-email' className='required'>이메일 주소</label>
                            <input
                                type='email'
                                className='user-email'
                                id='user-email'
                                name='email'
                                value={formValues.email}
                                onChange={handleChange}
                                placeholder='가입하신 이메일 주소를 입력해 주세요.'
                            />
                            <p className='caution'>*이메일 주소가 정확하지 않으면, 임시 비밀번호를 받으실 수 없습니다.</p>
                        </div>
                    </div>

                    {/* 제출 버튼 */}
                    <button type='submit' className='btn issued-temporary-password' disabled={!isFormValid}>임시 비밀번호 발급하기</button>
                </form>

            </div>
        </div>
    )
}

export default FindPassword
